import { ReactNode } from "react";
import ReadMore from "../ReadMore";
import "./ListTable.scss";

interface ListDesktopProps {
  children: ReactNode;
  readMeText?: string;
  readMeUrl?: string;
}

const ListDesktop = ({ children, readMeText, readMeUrl }: ListDesktopProps) => {
  return (
    <div className="listDesktop">
      <div className="listDesktopContent">{children}</div>
      <div className="listDesktopReadMore">
        {readMeText && readMeUrl && (
          <ReadMore text={readMeText} url={readMeUrl} />
        )}
      </div>
    </div>
  );
};

export default ListDesktop;
